import { User } from '@prisma/client'
import { Api } from '~/core/trpc'
import { OrganizationType } from '~/features/organization/common'

type DataType = OrganizationType & {
  company: { id: string; name: string; logoUrl?: string }
}

export const useOrganizations = (options: {
  isLoggedIn: boolean
  user: User
  isAllowed: boolean
}) => {
  const { isLoggedIn, isAllowed, user } = options

  const query = Api.organization.findMany.useQuery(
    {
      where: {
        members: {
          some: {
            userId: user?.id,
          },
        },
      },
      include: {
        company: {
          select: {
            id: true,
            name: true,
            logoUrl: true,
          },
        },
      },
      orderBy: [{ status: 'asc' }, { createdAt: 'desc' }],
    },
    {
      enabled: isLoggedIn && isAllowed && !!user?.id,
      initialData: [],
    },
  )

  const isReady = query.isFetched

  return { ...query, data: query.data as DataType[], isReady }
}
